import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Colors } from "../../assets";
import { StatusComponentProps } from "../../interfaces_and_types";
import "./styles.css";

const StatusComponent = (props: StatusComponentProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="status-component"
      style={{
        backgroundColor:
          props.status.isPreparing || props.status.isReady
            ? Colors.GREEN
            : Colors.PURPLE,
      }}
    >
      <p
        style={{
          fontSize: 16,
          fontWeight: "bold",
          color:
            props.status.isPreparing || props.status.isReady
              ? Colors.PURPLE
              : Colors.GREEN,
        }}
      >
        {props.status.isPreparing
          ? t("Preparing")
          : props.status.isReady
            ? t("Done")
            : props.status.isWaiting
              ? t("Waiting")
              : t("Canceled")}
      </p>
      <p
        style={{
          fontSize: 16,
          fontWeight: "bold",
          color:
            props.status.isPreparing || props.status.isReady
              ? Colors.PURPLE
              : Colors.GREEN,
        }}
      >
        {props.status.number}
      </p>
    </div>
  );
};

export default observer(StatusComponent);
